import { useRef, useState } from 'react';
import { alpha } from '@mui/material/styles';
import { Box, MenuItem, Stack, IconButton } from '@mui/material';
import MenuPopover from '../../components/MenuPopover';

const LANGS = [
	{
		value: 'en',
		label: 'English',
		icon: '/static/icons/ic_flag_en.svg',
	},
	// {
	// 	value: 'es',
	// 	label: 'Spanish',
	// 	icon: '/static/icons/ic_flag_es.svg',
	// },
	// {
	// 	value: 'fr',
	// 	label: 'French',
	// 	icon: '/static/icons/ic_flag_fr.svg',
	// },
	// {
	// 	value: 'de',
	// 	label: 'German',
	// 	icon: '/static/icons/ic_flag_de.svg',
	// },
	// {
	// 	value: 'zh',
	// 	label: 'Chinese',
	// 	icon: '/static/icons/ic_flag_zh.svg',
	// },
	// {
	// 	value: 'ja',
	// 	label: 'Japanese',
	// 	icon: '/static/icons/ic_flag_ja.svg',
	// },
	// {
	// 	value: 'ko',
	// 	label: 'Korean',
	// 	icon: '/static/icons/ic_flag_ko.svg',
	// },
	// {
	// 	value: 'hi',
	// 	label: 'Hindi',
	// 	icon: '/static/icons/ic_flag_hi.svg',
	// },
];

export default function LanguagePopover() {
	const anchorRef = useRef(null);
	const [open, setOpen] = useState(false);

	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	return (
		<>
			<IconButton
				ref={anchorRef}
				onClick={handleOpen}
				sx={{
					padding: 0,
					width: 44,
					height: 44,
					...(open && {
						bgcolor: (theme) =>
							alpha(
								theme.palette.primary.main,
								theme.palette.action.focusOpacity,
							),
					}),
				}}
			>
				<img src={LANGS[0].icon} alt={LANGS[0].label} />
			</IconButton>

			<MenuPopover
				open={open}
				onClose={handleClose}
				anchorEl={anchorRef.current}
				sx={{
					mt: 1.5,
					ml: 0.75,
					width: 180,
					'& .MuiMenuItem-root': {
						px: 1,
						typography: 'body2',
						borderRadius: 0.75,
					},
				}}
			>
				<Stack spacing={0.75}>
					{LANGS.map((option) => (
						<MenuItem
							key={option.value}
							selected={option.value === LANGS[0].value}
							onClick={() => handleClose()}
						>
							<Box
								component="img"
								alt={option.label}
								src={option.icon}
								sx={{ width: 28, mr: 2 }}
							/>

							{option.label}
						</MenuItem>
					))}
				</Stack>
			</MenuPopover>
		</>
	);
}
